import { all } from 'redux-saga/effects';

import AllocationWishSaga from 'redux/allocationWishes/sagas';
import CarrierPickupLocationSaga from 'redux/carrierPickupLocations/sagas';
import CartSaga from 'redux/cart/sagas';
import ClubMemberShipmentSaga from 'redux/clubMemberShipments/sagas';
import ClubMembershipSaga from 'redux/clubMemberships/sagas';
import ClubPackageSaga from 'redux/clubPackages/sagas';
import ClubSignupSaga from 'redux/clubSignup/sagas';
import ClubSubscriptionShipmentSaga from 'redux/clubSubscriptionShipments/sagas';
import ClubSaga from 'redux/clubs/sagas';
import CustomerSaga from 'redux/customer/sagas';
import CustomerAddressSaga from 'redux/customerAddresses/sagas';
import CustomerCreditCardSaga from 'redux/customerCreditCards/sagas';
import CustomerMetaDataSaga from 'redux/customerMetaData/sagas';
import FormSaga from 'redux/forms/sagas';
import InventoryLocationSaga from 'redux/inventoryLocations/sagas';
import LoyaltyTierSaga from 'redux/loyaltyTiers/sagas';
import LoyaltyTransactionSaga from 'redux/loyaltyTransactions/sagas';
import OrderSaga from 'redux/orders/sagas';
import PersonalizationBlockSaga from 'redux/personalizationBlock/sagas';
import ProductFilterSaga from 'redux/productFilters/sagas';
import ProductSaga from 'redux/products/sagas';
import ReservationAvailabilitySaga from 'redux/reservationAvailabilities/sagas';
import ReservationCartSaga from 'redux/reservationCart/sagas';
import ReservationTypeSaga from 'redux/reservationTypes/sagas';
import ReservationSaga from 'redux/reservations/sagas';
import SettingSaga from 'redux/settings/sagas';
import ShippingSaga from 'redux/shipping/sagas';

export default function* IndexSaga() {
  yield all([
    AllocationWishSaga(),
    CarrierPickupLocationSaga(),
    CartSaga(),
    ClubSaga(),
    ClubMembershipSaga(),
    ClubMemberShipmentSaga(),
    ClubPackageSaga(),
    ClubSignupSaga(),
    ClubSubscriptionShipmentSaga(),
    CustomerSaga(),
    CustomerAddressSaga(),
    CustomerCreditCardSaga(),
    CustomerMetaDataSaga(),
    FormSaga(),
    InventoryLocationSaga(),
    LoyaltyTierSaga(),
    LoyaltyTransactionSaga(),
    OrderSaga(),
    PersonalizationBlockSaga(),
    ProductSaga(),
    ProductFilterSaga(),
    ReservationAvailabilitySaga(),
    ReservationCartSaga(),
    ReservationSaga(),
    ReservationTypeSaga(),
    SettingSaga(),
    ShippingSaga()
  ]);
}
